"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerFilteringParameters = void 0;
var FilteringParameters_1 = require("../client/FilteringParameters");
/**
 * Describes filtering parameters that can be used when retrieving servers.
 * When pagination parameters are not specified, default values are set.
 */
var ServerFilteringParameters = /** @class */ (function (_super) {
    __extends(ServerFilteringParameters, _super);
    function ServerFilteringParameters(count, offset, name) {
        if (count === void 0) { count = 100; }
        if (offset === void 0) { offset = 0; }
        var _this = _super.call(this, count, offset) || this;
        _this.name = name;
        return _this;
    }
    return ServerFilteringParameters;
}(FilteringParameters_1.FilteringParameters));
exports.ServerFilteringParameters = ServerFilteringParameters;
//# sourceMappingURL=ServerFilteringParameters.js.map